module.exports = __webpack_public_path__ + "static/media/lu.8b872c1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/lu.svg
// module id = 1456
// module chunks = 0